
import type { App } from 'vue'

/* Npm Plugins */
import { createI18n } from 'vue-i18n'
import type { I18n, I18nOptions } from 'vue-i18n'

/* Store */
import { useLocaleStoreWithOut } from '../../store/locale';

export const setHtmlPageLang = (locale: LocaleType) => {
    document.querySelector('html')?.setAttribute('lang', locale)
}

export let i18n: ReturnType<typeof createI18n> | any

const createI18nOptions = async (): Promise<I18nOptions> => {
    const localeStore = useLocaleStoreWithOut()

    const locale = localeStore.getCurrentLocale

    const localeMap = localeStore.getLocaleMap

    const defaultLocal = await import(`../../locales/${locale.lang}.ts`)

    const message = defaultLocal.default ?? {}

    setHtmlPageLang(locale.lang)

    localeStore.setCurrentLocale({ lang: locale.lang })

    const config = {
        legacy: false,
        locale: locale.lang,
        fallbackLocale: locale.lang,
        messages: {
            [locale.lang]: message
        },
        availableLocales: localeMap.map((v) => v.lang),
        sync: true,
        silentTranslationWarn: true,
        missingWarn: false,
        silentFallbackWarn: true
    }

    return config
}

export const setupI18n = async (app: App<Element>) => {

    const options = await createI18nOptions()

    i18n = createI18n(options) as I18n

    app.use(i18n)

}
